import ErrorBase, { ErrorSeverity } from './ErrorBase';
export default class UnavailableMethodException extends ErrorBase {
    constructor(loggingDetails = {}) {
        super('This method is not available', loggingDetails, ErrorSeverity.WARNING);
        this.name = 'UnavailableMethodException';
    }
}
